/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ChannelPreferenceEnum {
    DIGITAL = 'DIGITAL',
    DIGITAL_PAPER = 'DIGITAL_PAPER',
    PAPER = 'PAPER',
}
